import ModalMixin from '../../../mixins/modal-alerts'

const mixins = [ModalMixin]

export default {
  name: 're-alert',
  type: 'alert',
  mixins
}
